// import RootStore from 'stores/RootStore';
import RootStore from "stores/RootStore";
import ServiceStore from "stores/ServiceStore";
import type { RouteType } from "types/RouteType";
import ProductionScheduleStore from "./ProductionScheduleStore";
// import IFCTrackerLeftHeaderCell from './IFCTracker.LeftHeaderCell';
// import IFCTrackerRightHeaderCell from './IFCTracker.RightHeaderCell';

// import * as utils from '@intrasync/utils';
// import * as utils from '@intrasync/utils';
// // import IFCTrackerIcon from '@mui/icons-material/GridOn';
// import { toJS } from 'mobx';
// import IFCTrackerStore from 'stores/IFCTrackerStore';
// import ServiceStore from 'stores/ServiceStore';

const ifcTrackerRoute: RouteType[] = [
  {
    name: "Production Schedule",
    path: "/job/:jobNumber/production-schedule",
    layout: "/app",
    viewportCard: {
      header: {
        title: "Production Schedule",
        component: () => import("./ProductionSchedule.Header"),
        enableToolbox: true,
        enableBackButton: true,
        enableRefreshButton: true,
      },
      body: {
        scheduleContainer: {
          namespace: "ProductionSchedule",
          storeName: "productionScheduleStore",
          dateKey: "castingDate",
          dateRangeKey: "dateRange",
          rowHeight: (rowIndex: { index: number }, rootStore) => {
            const productionScheduleStore =
              rootStore?.productionScheduleStore as ProductionScheduleStore;
            // console.log('rowIndex', rowIndex);
            // console.log('rootStore', rootStore);
            return productionScheduleStore.getRowHeight(rowIndex.index);
          },
          enableSaveLocation: true,
        },
      },
    },
    group: 'Scheduling',
  requiresAuth: true, // Assuming it requires authentication since it requires permission
    requiresPermission: false,
    dialogs: [
      {
        name: "panelDetails",
        title: "Panel Details",
        component: () =>
          import("./ProductionScheduleDialogs/ProductionSchedule.PanelDetails"),
        cancelButton: true,
        height: 500,
      },
      {
        name: "addPanel",
        title: "Add New Panel",
        component: () =>
          import("./ProductionScheduleDialogs/ProductionSchedule.AddPanel"),
        cancelButton: false, // The dialog has its own cancel button
        height: 600,
      },
      {
        name: "setCapacity",
        title: "Set Daily Capacity",
        component: () =>
          import("./ProductionSchedule.CapacityDialog"),
        cancelButton: false, // The dialog has its own cancel button
        height: 750,
      },
    ],
    // permissionPath: '/app/ifc-tracker', // Maintaining permission path for consistency
    // defaultQueryParams: {
    //   productType: `job-stats/panel-count/:jobNumber.jobsProductTypes`,
    // },
    projectRoute: true,
    channels: [
      "job/:jobNumber",
      "job/:jobNumber",
      "panel-revit/:jobNumber",
      "panel-plant/:jobNumber",
      "panel-yard/:jobNumber",
      "dates/holidays",
      "ifc-status/:jobNumber",
      "hold/:jobNumber",
      "comments",
      "mold-engineer-assignment/:jobNumber",
      "job-stats/panel-count/:jobNumber",
    ],
    enableAutoFind: false,
    onEnter: async ({ rootStore }: { rootStore: RootStore }) => {
      const panelStore = rootStore.panelStore as ServiceStore;
      const manhourCapacityStore = rootStore.manhourCapacityStore as ServiceStore;
      const routerStore = rootStore.routerStore;
      const jobNumber = routerStore?.params?.jobNumber;

      // Load panels for this job
      panelStore.find({
        query: {
          jobNumber: jobNumber,
        },
      });

      // Load manhour capacity standards
      manhourCapacityStore.find({
        query: {
          $sort: { effectiveDate: -1 },
        },
      });
    },
    // onEnter: async ({
    //   rootStore,
    //   params,
    // }: {
    //   rootStore: RootStore;
    //   params: RouteParamsType;
    // }) => {
    // const ifcTrackerStore = rootStore.ifcTrackerStore as IFCTrackerStore;
    // const jobStatsIfcStatusStore =
    //   rootStore.jobStatsIfcStatusStore as ServiceStore;
    // const { clearMultiSelectArray, multiSelectArray } = ifcTrackerStore;
    // const { get: getIfcStats } = jobStatsIfcStatusStore;
    // const { jobNumber } = toJS(params);
    // getIfcStats(jobNumber as number);
    // if (multiSelectArray && multiSelectArray.length > 0) {
    //   clearMultiSelectArray();
    // }
    //   const {
    //     ifcTrackerStore: { setStartDate, setEndDate },
    //     panelStore: { find: findPlantPanels },
    //   } = rootStore;
    //   const { jobNumber } = toJS(params);
    //   const { productType } = toJS(queryParams);

    //   let startDateTemp = `${utils.getYearFromDate(new Date())}-01-01`;
    //   let endDateTemp = `${utils.getYearFromDate(new Date())}-12-31`;

    //   const startCastingDateResponse = await findPlantPanels({
    //     query: {
    //       productType: productType,
    //       jobNumber: jobNumber,
    //       $limit: 1,
    //       $sort: { castingDate: 1 },
    //       castingDate: { $nin: ['1970-01-01'] },
    //     },
    //   });
    //   if (
    //     startCastingDateResponse &&
    //     startCastingDateResponse.data &&
    //     startCastingDateResponse.data.length
    //   ) {
    //     const smallCastingDateResponse = startCastingDateResponse.data[0];
    //     if (smallCastingDateResponse && smallCastingDateResponse.castingDate) {
    //       startDateTemp = smallCastingDateResponse.castingDate;
    //     }
    //   }
    //   setStartDate(startDateTemp);

    //   const endCastingResult = await findPlantPanels({
    //     query: {
    //       productType,
    //       jobNumber,
    //       $limit: 1,
    //       $sort: { castingDate: -1 },
    //       castingDate: { $nin: ['1970-01-01'] },
    //     },
    //   });
    //   if (
    //     endCastingResult &&
    //     endCastingResult.data &&
    //     endCastingResult.data.length
    //   ) {
    //     const largestCastingResult = endCastingResult.data[0];

    //     if (largestCastingResult && largestCastingResult.castingDate) {
    //       endDateTemp = largestCastingResult.castingDate;
    //     }
    //   }

    //   setEndDate(endDateTemp);
    // },
    // onParamsChange: async ({
    //   rootStore,
    //   params,
    //   queryParams,
    //   previousParams,
    //   previousQueryParams,
    // }) => {
    //   if (
    //     queryParams?.productType !== previousQueryParams.productType ||
    //     !utils.isSameJobNumber(params?.jobNumber, previousParams.jobNumber)
    //   ) {
    //     rootStore.routerStore.triggerEnterSideEffects();
    //   }
    // },
    // onExit: async ({ rootStore }) => {
    //   const {
    //     ifcTrackerStore: {
    //       clearMultiSelectArray,
    //       setScrollToColumn,
    //       setScrollToRow,
    //       setCurrentHighlightPanel,
    //     },
    //   } = rootStore;
    //   clearMultiSelectArray();
    //   setCurrentHighlightPanel({});
    //   setScrollToRow(0);
    //   setScrollToColumn(0);
    // },
  },
];

export default ifcTrackerRoute;
